<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
      <v-row>
        <v-col
          cols="12"
        >
        <ValidationProvider
              rules="required"
              vid="numero_bolla"
              :name="$t('fields.numero_bolla').toLowerCase()"
              v-slot="{ errors }"
          >
            <v-text-field
              v-model=" form.numero_bolla"
              :counter="30"
              :label="$t('fields.numero_bolla')"
              :error-messages="errors"
            ></v-text-field>

          </ValidationProvider>
        </v-col>
      </v-row>
      <BookSelection
        v-model="bookSelected"
      >
      </BookSelection>
      <v-simple-table
                  fixed-header
                  height="600px"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{$t('fields.isbn')}}
                        </th>
                        <th class="text-left">
                          {{$t('fields.book')}}
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in bookSelected"
                        :key="item.id"
                      >
                        <td>{{ item.isbn }}</td>
                        <td>{{ item.title }} {{ item.volume }}</td>
                        <td>
                          <v-layout row wrap>
                            <v-flex>
                              <v-text-field
                                v-model="form.qtySelected[item.isbn]"
                                :counter="30"
                                :error-messages="errors"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  import BookSelection from '../../app/Books/BookSelection.vue';

  export default {
    name: 'WarehouseLoadModal',
    components: {
      BookSelection,
    },
    data() {
      return {
        stored: null,
        form: {
          numero_bolla: null,
          qtySelected: {},
        },
        bookSelected: [],
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      getActiveIDs() {
        return this.bookSelected.map(x => x.isbn);
      },

      getQtySelected() {
        if (this.qtySelected !== undefined) {
          Object.keys(this.form.qtySelected).forEach(element => {
            if (!this.getActiveIDs.includes(Number(element))) {
              delete this.form.qtySelected[element];
            }
          });

          return this.qtySelected;
        }

        return {};
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
    },
  };
</script>
